import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-umbrella-sea",
  "use": "icon-si-glyph-umbrella-sea-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-umbrella-sea\" id=\"icon-si-glyph-umbrella-sea\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>988</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M8.469,1 L1,7 L1,8.984 L1.953,8.984 L1.953,7.984 L4,7.984 L4,8.984 L5.969,8.984 L5.969,7.984 L8.016,7.984 L8.016,8.578 L8.016,8.984 L8.016,15.031 L5.002,15.031 L5.002,16.031 L3,16.031 L3,16.938 L13.938,16.938 L13.938,16.031 L12,16.031 L12,15.031 L8.964,15.031 L8.964,8.984 L8.969,8.984 L8.969,7.984 L11.047,7.984 L11.047,8.984 L13,8.984 L13,7.984 L15.016,7.984 L15.016,8.984 L16,8.984 L16,7 L8.469,1 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-umbrella-sea.svg
// module id = ai1L
// module chunks = 62